













































































































































































































































































import Vue from 'vue';
import * as deviceFactory from './deviceFactory';
import config from './map.config';
import mapStyles from './mapStyles';
import Utils from '@/modules/Utils';
import PropUtils from '@/modules/PropUtils';
import API, { Types } from '@/modules/API';
import isEqual from 'lodash/isEqual';
import { cloneDeep } from 'lodash';
import ExportData from '@/components/ExportData.vue';
import moment from 'moment';
import { gmapApi } from '@/plugins/google-maps';
import PropEditor from '@/components/PropEditor.vue';
import ConfirmDialog from '@/components/dialogs/ConfirmDialog.vue';
import GifLoading from '@/components/GifLoading.vue';
import Legend from '@/pages/mapView/Legend.vue';
import MQTT from '@/modules/MQTT';
import { Device, FloodSensor, GmapMapRef } from '@/modules/Types';
import { getMapIcon } from '@/pages/mapView/components/map/getMapIcon';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';

const mapMaxZoom = 23;
const mapMinZoom = 2;

const defaultStyleSheet = [
  { value: 'defaultMode', name: 'Default' },
  { value: 'silverMode', name: 'Silver' },
  { value: 'nightMode', name: 'Night mode' }
];

@Component({ 
  components: {
    Legend,
    ExportData,
    PropEditor,
    ConfirmDialog,
    GifLoading
}})
class GoogleMap extends Vue {
  
  @Prop() loadingDevices: boolean;
  @Prop() current_device: object;
  @Prop() is_device_info_open: boolean;
  @Prop() devices: [];
  @Prop() filter: object;
  @Prop() lang: string;
  @Prop() infoFromMapview: string;
  @Prop() showSelectionTools: boolean;
  @Prop() group: boolean;
  @Prop() groupDevices;
  @Prop() dragOnly: boolean;
  @Prop() unassigned: boolean;
  @Prop() searchClicked: boolean;
  @Prop() tab: string;
  @Prop() setSearchClicked: (clicked: boolean) => void;
  @Prop() clearDeviceData: () => void;
  @Prop() fullMap: boolean;
  @Prop() setIsFullMap: (is_full_map: boolean) => void;

    cloneDeep = cloneDeep;
    mqtt = MQTT.instance;
    cabinet_circuits = new Map();
    cabinet_connected_percent = new Map();
    confirmDragDialog = false;
    map_layers = new Map();
    isDefaultCabinet = false;
    dragPrevLocation = {lat: null, lng: null};
    dragCurrentLocation = {lat: null, lng: null};
    dragMarker = null;
    dragStarted = false;
    dragFeature = null;
    draggableFeatures = new Map();
    // cabinets: new Map(),
    // cabinet_ids: [],
    // cabinets_devices: new Map(),
    // fullviewPage: false,
    markers_map = new Map();
    map = null;
    cabinetPage = false;
    showAdvancedLocations = false;
    tommorow = null;
    yesterday = null;
    today_00 = null;
    today_23 = null;
    search_value = '';
    showLegend = true;
    center = { lat: 32.08816963237704, lng: 34.79698850793454 };
    markers = [];
    mapStyles = {};
    device = null;
    boundsOptions = {
      padding: 65,
      screenSpeed: 8
    };
    infoPositionCurrent = null;
    infoOpenedCurrent = null;
    infoContentCurrent = null;
    infoOptionsCurrent = {
      disableAutoPan: true,
      pixelOffset: {
        width: 0,
        height: -35
      },
      zIndex: -10000
    };
    hasCustomMapStyles = false;
    styleList = defaultStyleSheet;
    customMapStyles = {};
    mapMode = 'defaultMode';
    wrapStyles = { 'border-radius': '20px', 'outline': 'none !important' };
    openSearch = false;
    showSettings = false;
    apiKey = config.TOKEN_GOOGLE;
    mapOptions = {
      disableDefaultUI: true,
      scaleControl: true,
      zoomControl: true,
      fullscreenControl: true,
      styles: mapStyles.defaultMode,
      maxZoom: mapMaxZoom,
      minZoom: mapMinZoom
    };
    showCircuitNumbers = false;
    isSatelliteMap = false;
    showHeatMap = false;
    redHeatMap = null;
    redHeatMapPoints = [];
    yellowHeatMap = null;
    yellowHeatMapPoints = [];
    greenHeatMap = null;
    greenHeatMapPoints = [];
    gradientGreen = [
      'rgba(139,255,82,0)',
      'rgba(139,255,22,1)',
      'rgba(139,255,22,1)',
      'rgba(139,255,22,1)',
      'rgba(139,255,22,1)'
    ];
    gradientYellow = [
      'rgba(139,255,82,0)',
      'rgba(239,250,1, 1)',
      'rgba(239,250,1, 1)',
      'rgba(239,250,1, 1)',
      'rgba(239,250,1, 1)'
    ];
    gradientRed = [
      'rgba(209, 0, 0, 0)',
      'rgba(229, 0, 0, 1)',
      'rgba(229, 0, 0, 1)',
      'rgba(229, 0, 0, 1)',
      'rgba(229, 0, 0, 1)'
    ];
    location = null;
    projectName = null;
    advancedLocations = {markers: false, gps: false, gis: false, app: false};
    polygonLocations = [];
    polygonMarkers = [];
    polygon = null;
    polyline = null;
    polyline1 = null;
    polyline2 = null;
    polygonDevices = [];
    mapCurrentBounds = { hiLat: 0, loLat: 0, hiLng: 0, loLng: 0 }; // highLat lowLat highLng lowLng
    map_layers_listeners = new Map();
    deviceSelectorChecked = false;
    $gmapApiPromiseLazy!: () => Promise<any>;
    $refs!: { 
      propEditor: InstanceType<typeof PropEditor>,
      map: GmapMapRef
    };
  
    get google() { return gmapApi(); }

    get readonly_user() {
      return this.$store.state.Global.readonly_user;
    }

    get day_of_week(){
      return this.$store.state.Global.day_of_week;
    }

    get projectDefaultLocation(){
      return this.$store.state.Props.project_default_location;
    }

    get displayFullMapBtn() {
      return this.$route.path === '/' && !this.current_device && !this.searchClicked && !this.group;
    }

    get isMobile() {
      return this.$store.state.Global.isMobile;
    }

    get filteredDevicesRoute(){
      return this.$route.path.includes('/filter/create') 
        || this.$route.path.includes('custom') 
        || this.$route.path.includes('cabinet-details')
        || this.$route.path.includes('monitoring_report')
        || this.$route.params.cid
        || this.tab && this.tab.includes('multiple-search');
    }

    get deviceDrag() {
      return this.$store.state.MapSettings.deviceDrag;
    }

    get mapHeight(){
      return this.$route.path.includes('monitoring_report') 
        ? 'map-height-install-report' 
        : this.$route.path.includes('cabinet-details')
          ? 'map-height-cabinet-page'
          : this.fullMap
            ? 'map-height-full'
            : this.$route.path.includes('/groups')
              ? 'map-height-group'
              : this.current_device && this.isMobile
                ? 'map-height-device-and-mobile'
                : 'map-height-project-info';
    }

    get projectProperties() {
      return this.$store.state.Props.list;
    }


    // heatPoints() {
    //   if (this.markers.length < 1) return [];

    //   const heatmap_points = [];
    //   this.markers.forEach((marker) => {
    //     const heat_point = {lat: marker['meta.location'].lat, lng: marker['meta.location'].lng, weight: null};
    //     heat_point.weight = marker.rssi ? marker.rssi : marker.rssi === 0 ? 0 : null;
    //     heatmap_points.push(heat_point);
    //   });
    //   return heatmap_points;
    // }

  beforeMount() {
    this.location = this.$route.path;
    this.projectName = this.$store.state.User.project.name;
    this.$store.commit('MapSettings/setDeviceRepositioning', false);
  }

  beforeDestroy(){
    this.removeMapLayersListeners();
    this.map = null;
    if (this.mqtt && !this.$route.path.includes('cabinet-details')) {
      this.mqtt.clearListeners();
    }
  }

  mounted() {
    this.mqtt.listenToProjectEvents();
    this.$root.$refs.GoogleMap = this;
    this.cabinetPage = this.$route.path.includes('cabinet-details');
    // this.fullviewPage = this.$route.path === '/';
    this.setDatesInfo();
    this.initSearch();
    this.getProjectMapStyles();
    this.setMapResize();
    this.setMapBounds([]);
  }

  setMapLayers(){
    this.setDataMapLayer('markers');
    this.setDataMapLayer('gps');
    this.setDataMapLayer('gis');
    this.setDataMapLayer('app');
  }

  setDatesInfo() {
    this.yesterday = moment(+localStorage.getItem('now')).subtract(1, 'days').valueOf();
    this.tommorow = moment(+localStorage.getItem('now')).add(1, 'days').valueOf();
    this.today_00 = moment(+localStorage.getItem('now')).set({ hour: 0, minute: 0, second: 0, millisecond: 0 }).valueOf();
    this.today_23 = moment(+localStorage.getItem('now')).set({ hour: 23, minute: 59, second: 59, millisecond: 59 }).valueOf();
  }

  showHeatMaps(value) {
    this.redHeatMap.setMap(value);
    this.yellowHeatMap.setMap(value);
    this.greenHeatMap.setMap(value);
  }

  setAdvancedLocationsIsOpen() {
    if (this.showSettings) this.showSettings = false;
    this.showAdvancedLocations = !this.showAdvancedLocations;
    if (!this.showAdvancedLocations){
      this.clearPolylines();
      this.clearAdvancedLocations();
    }
  }

  clearAdvancedLocations(){
    if (!this.advancedLocations.markers) {
      Vue.set(this.advancedLocations, 'markers', true);
      this.map_layers.get('markers').setMap(this.map);
    }
    if (this.advancedLocations.gps){
      Vue.set(this.advancedLocations, 'gps', false);
      this.map_layers.get('gps').setMap(null);
    }
    if (this.advancedLocations.gis){
      Vue.set(this.advancedLocations, 'gis', false);
      this.map_layers.get('gis').setMap(null);
    }
    if (this.advancedLocations.app){
      Vue.set(this.advancedLocations, 'app', false);
      this.map_layers.get('app').setMap(null);
    }
  }
    // generateHeatmapLayers(){
    //   this.$nextTick(() => {
    //     this.$refs.map.$mapPromise.then(() => {
    //       const self = this;
    //       try {
    //         this.heatPoints.forEach((coord) => {
    //           if (coord.weight === null) return null;
    //           if (coord.weight < -100) {
    //             this.redHeatMapPoints.push(new google.maps.LatLng(coord.lat, coord.lng));
    //           } else if (coord.weight < -80) {
    //             this.yellowHeatMapPoints.push(new google.maps.LatLng(coord.lat, coord.lng));
    //           } else {
    //             this.greenHeatMapPoints.push(new google.maps.LatLng(coord.lat, coord.lng));
    //           }
    //         });
    //         this.redHeatMap = this.createHeatMapLayer(this.redHeatMapPoints, this.gradientRed, self);
    //         this.yellowHeatMap = this.createHeatMapLayer(this.yellowHeatMapPoints, this.gradientYellow, self);
    //         this.greenHeatMap = this.createHeatMapLayer(this.greenHeatMapPoints, this.gradientGreen, self);
    //       } catch (error) {
    //         console.log(error);
    //       }
    //     });
    //   });
    // },
    toggleHeatMap() {
      this.showHeatMap = !this.showHeatMap;
      this.showHeatMap ? this.showHeatMaps(this.map) : this.showHeatMaps(null);
    }

    createHeatMapLayer(data, gradient, self){
      return new google.maps.visualization.HeatmapLayer({
        data,
        map: self.$refs.map.$mapObject,
        radius: 30,
        gradient,
        maxIntensity: 3
      });
    }

    toggleCircuitNumbers() {
      this.showCircuitNumbers = !this.showCircuitNumbers;
      // Iterate over actual map features to avoid race conditions with markers array
      this.map_layers.get('markers').forEach((feature) => {
        const marker = this.markers_map.get(feature.getId());
        if (marker) {
          this.updateFeatureIcon(marker);
        }
      });
    }

    toggleSatelliteMap() {
      if (this.showSettings) this.showSettings = false;
      this.isSatelliteMap = !this.isSatelliteMap;
      if (this.isSatelliteMap) {
        this.$refs.map.$mapObject.setMapTypeId('hybrid');
      } else {
        this.$refs.map.$mapObject.setMapTypeId('roadmap');
      }
    }

    refreshMap() {
      this.$refs.map.$mapObject.setMapTypeId('hybrid');
    }

    setMapResize() {
      const observer = new MutationObserver((m) => {
        this.setMapStyle('height', m[0].target['clientHeight'] + 'px');
        if (this.map && typeof google !== 'undefined' && google.maps) {
          google.maps.event.trigger(this.map, 'resize');
        }
      });
      const child = document.getElementsByClassName('map-container')[0];
      observer.observe(child, { attributes: true });
    }

    smoothZoom(level, cnt) {
      if (cnt >= level) {
        return;
      } else {
        const z = this.map.addListener('zoom_changed', (e) => {
          google.maps.event.removeListener(z);
          this.smoothZoom(level, cnt + 1);
        });
        setTimeout(() => {
          this.map.setZoom(cnt);
        }, 80);
      }
    }

    updateDeviceSelectorData() {
      if (this.showAdvancedLocations) this.setAdvancedLocationsIsOpen();
      if (this.deviceSelectorChecked) {
        this.clearDeviceSelector();
        return;
      }
      this.deviceSelectorChecked = true;
      this.$emit('chooseDevicesSelected', true);
    }

    clearDeviceSelector(){
      this.deviceSelectorChecked = false;
      this.clearPolySelection();
      if (!this.$route.path.includes('/groups/')){
        this.$emit('chooseDevicesSelected', false);
        this.$emit('selectedChanged', this.groupDevices && this.groupDevices.size ? [...this.groupDevices.values()] : []);
      }
    }

    setIsSelectorChecked(){
      if (this.deviceSelectorChecked) {
        this.deviceSelectorChecked = false;
        this.clearPolySelection();
        return;
      }
      this.deviceSelectorChecked = true;
    }

    getMarkerOptions(marker, layer) {
      let icon, metaDevice, final_marker = null;
      try {
        if (marker['meta.device']){
          metaDevice = marker['meta.device'];
          final_marker = marker;
        }else {
          final_marker = this.$store.getters['Reports/commissioned_map'].get(marker.id);
          metaDevice = final_marker['meta.device'];
        }
        icon = this.calculateMarkerIcon(final_marker);
      } catch (e) {
        console.warn('error getting icon', e);
      }
      return {
        icon
      };
    }

    getCabinetPageMarkerOptions(marker) {
      let icon, circuit_number;
      try {
        const metaDevice = marker['meta.device'];
        circuit_number = Utils.hasTondoClass(marker['meta.category'].category)
          ? metaDevice.circuit_number
          : '';

        icon = this.calculateMarkerIcon(marker);
      } catch (e) {
        icon = '';
        circuit_number = '';
        console.log(`no circuit_number for ${marker.id}`);
      }

      return {
        icon,
        label:
          (this.showCircuitNumbers && circuit_number && {
            color: '#DA0AAA',
            fontWeight: 'bold',
            fontSize: '14px',
            text: circuit_number.toString()
          }) ||
          ''
      };
    }

    calculateMarkerIcon(device) {
      const isSelected = this.group &&
                         this.groupDevices &&
                         this.groupDevices.size &&
                         this.groupDevices.has(device.id);
      return {
        url: config.icons[getMapIcon(device, isSelected)],
        scaledSize: new google.maps.Size(18, 18)
      };
    }

    overrideFeaturesStyle(layer_name){
      try {
        this.map_layers.get('markers').forEach((feature) => {
          try {
            const featureId = feature.getId();
            const marker = this.markers_map.get(featureId);
            
            if (!marker) {
              console.warn(`Marker not found for feature ID: ${featureId}`);
              return;
            }
            
            const options = this.getMarkerOptions(marker, 'advanced');
            const properties = {icon: options.icon, zIndex: feature.getProperty('zIndex') || 0, draggable: false};
            this.map_layers.get('markers').overrideStyle(feature, properties);
          } catch (featureError) {
            console.error(`Error processing feature in 'advanced' mode:`, featureError);
            console.error('Feature ID:', feature ? feature.getId() : 'unknown');
          }
        });
        this.map_layers.get('markers').setMap(this.map);
      } catch (error) {
        console.error(`Error in overrideFeaturesStyle for layer: ${layer_name}`, error);
      }
    }
    
    clearMapData(){
      if (this.filteredDevicesRoute) {
        this.removeAllLayerFeatures('markers');
        this.markers_map = new Map();
        this.markers = [];
      }
      this.isDefaultCabinet = false;
      this.showAdvancedLocations = false;

      this.clearPolylines();
      this.clearAdvancedLocations();
    }
    
    getCommissionedDevices(){
      let commissioned = this.getInstalledWithValidLocation();
      if (this.unassigned){
        this.isDefaultCabinet = true;
        commissioned = commissioned.filter((device) => this.isMarkerInsideMapBounds(device));
      }
      return commissioned;
    }
    
    setMarkerInformation() {
      this.setMapLayers();
      this.clearMapData();
      this.setMarkersMapData();
      this.markers = [...this.markers_map.values()];
      this.setMapLayersStyles();
      this.setMapLayersListeners();
      this.map_layers.get('markers').setMap(this.map);
      this.$nextTick(() => {
        if (this.markers.length && this.cabinetPage && !this.unassigned || !this.cabinetPage) this.setMapBounds(this.markers);
      });
    }
    
    setMapLayersStyles(){
      this.addDataLayerStyles(this.map_layers.get('markers'), 2);
      this.addDataLayerStyles(this.map_layers.get('gps'), 1);
      this.addDataLayerStyles(this.map_layers.get('gis'), 1);
      this.addDataLayerStyles(this.map_layers.get('app'), 1);
    }
    
    setMapLayersListeners(){
      this.addDataLayerListeners(this.map_layers.get('markers'), 'markers');
    }
    
    removeMapLayersListeners(){
      this.removeLayerListener(this.map_layers.get('markers'), 'markers');
    }
    
    removeLayerListener(layer, layer_name){
      if (typeof google === 'undefined' || !google.maps || !google.maps.event) {
        return;
      }
      if (this.checkLayerHasListener(layer, layer_name, 'click')){
        google.maps.event.removeListener(this.map_layers_listeners.get(`${layer_name}_click`));
      }
      if (this.checkLayerHasListener(layer, layer_name, 'mouseup')){
        google.maps.event.removeListener(this.map_layers_listeners.get(`${layer_name}_mouseup`));
      }
      if (this.checkLayerHasListener(layer, layer_name, 'mousedown')){
        google.maps.event.removeListener(this.map_layers_listeners.get(`${layer_name}_mousedown`));
      }
      if (this.checkLayerHasListener(layer, layer_name, 'mouseout')){
        google.maps.event.removeListener(this.map_layers_listeners.get(`${layer_name}_mouseout`));
      }
      if (this.checkLayerHasListener(layer, layer_name, 'mouseover')){
        google.maps.event.removeListener(this.map_layers_listeners.get(`${layer_name}_mouseover`));
      }
      this.map_layers_listeners = new Map();
    }
    
    checkLayerHasListener(layer, layer_name, event_name){
      if (typeof google === 'undefined' || !google.maps || !google.maps.event) {
        return false;
      }
      return google.maps.event.hasListeners(layer, event_name) &&
        this.map_layers_listeners.has(`${layer_name}_${event_name}`) &&
        this.map_layers_listeners.get(`${layer_name}_${event_name}`);
    } 

    setMarkersMapData(){
      const commissioned = this.getCommissionedDevices();
      commissioned.forEach((device) => {
        const marker = device;
        this.setExtraDeviceData(marker);
        this.addFeature(marker, this.map_layers.get('markers'), 'advanced');

        this.markers_map.set(marker['id'], marker);
      });
    }

    setExtraDeviceData(marker){
      if (Utils.hasTondoClass(marker['meta.category'].category)) {
        this.setExtraFixtureData(marker);
      } else if (Utils.hasFloodSensorClass(marker['meta.category'].category)){
        this.setExtraFloodSensorData(marker);
      }
    }

    setExtraFixtureData(marker){
      marker.low_power_alert = !marker.hasOwnProperty('low_power_alert') ? 0 : +marker.low_power_alert;
      if (marker.hasOwnProperty('meta.install_location') && marker['meta.install_location']) this.setInstallLocationData(marker);
    }

    setExtraFloodSensorData(marker){
      marker[FloodSensor.BOTTOM_FLOAT_TRIGGER] = !marker.hasOwnProperty(FloodSensor.BOTTOM_FLOAT_TRIGGER) ? 0 : +marker[FloodSensor.BOTTOM_FLOAT_TRIGGER];
      marker[FloodSensor.TOP_FLOAT_TRIGGER] = !marker.hasOwnProperty(FloodSensor.TOP_FLOAT_TRIGGER) ? 0 : +marker[FloodSensor.TOP_FLOAT_TRIGGER];
      marker[FloodSensor.ULRASONIC_SENSOR_TRIGGER] = !marker.hasOwnProperty(FloodSensor.ULRASONIC_SENSOR_TRIGGER) ? 0 : +marker[FloodSensor.ULRASONIC_SENSOR_TRIGGER];
    }

    setDataMapLayer(name){
      if (this.map_layers.has(name)) {
        return;
      }
      const layer = new google.maps.Data();
      this.map_layers.set(name, layer);
    }

    setInstallLocationData(marker){
      let install_location_prop = marker['meta.install_location'];
      if (!install_location_prop || typeof install_location_prop !== 'object'){
        install_location_prop = {
          gps_location: { lat: '', lng: '' },
          app_location: { lat: '', lng: '' },
          gis_location: { lat: '', lng: '' },
          manual_location: { lat: '', lng: '' }
        };
        marker['meta.install_location'] = install_location_prop;
      }

      if (install_location_prop.hasOwnProperty('gps_location') && Utils.isValidLocation(install_location_prop['gps_location'])){
        const coords = {lat: parseFloat(install_location_prop['gps_location'].lat), lng: parseFloat(install_location_prop['gps_location'].lng)};
        this.addCircleFeature(`gps_${marker.id}`, coords, 'gpsCircle', 24, 'gps');
      }
      if (install_location_prop.hasOwnProperty('gis_location') && Utils.isValidLocation(install_location_prop['gis_location'])){
        const coords = {lat: parseFloat(install_location_prop['gis_location'].lat), lng: parseFloat(install_location_prop['gis_location'].lng)};
        this.addCircleFeature(`gis_${marker.id}`, coords, 'gisCircle', 28, 'gis');
      }
      if (install_location_prop.hasOwnProperty('app_location') && Utils.isValidLocation(install_location_prop['app_location'])){
        const coords = {lat: parseFloat(install_location_prop['app_location'].lat), lng: parseFloat(install_location_prop['app_location'].lng)};
        this.addCircleFeature(`app_${marker.id}`, coords, 'appCircle', 32, 'app');
      }
    }

    addCircleFeature(id, coordinates, circle_name, icon_size, layer_name){
      const icon = {
        url: config.icons[circle_name],
        scaledSize: new google.maps.Size(icon_size, icon_size)
      };
      const feature = new google.maps.Data.Feature({
        id,
        geometry: new google.maps.Data.Point({...coordinates}),
        properties: {
          icon
        }
      });
      this.map_layers.get(layer_name).add(feature);
    }

    addFeature(marker, layer, layer_name){
      const options = this.cabinetPage && this.getCabinetPageMarkerOptions(marker) || this.getMarkerOptions(marker, layer_name);
      const feature = new google.maps.Data.Feature({
        id: marker.id,
        geometry: new google.maps.Data.Point({lat: marker['meta.location'].lat, lng: marker['meta.location'].lng}),
        properties: {
          icon: options.icon
        }
      });
      if (this.cabinetPage && !this.isDefaultCabinet) feature.setProperty('label', options['label']);
      layer.add(feature);
    }

    addDataLayerStyles(layer, zIndex){
      layer.setStyle((feature) => {
        const styles = {icon: feature.getProperty('icon'), zIndex, draggable: false};
        if (feature.getProperty('label') !== undefined) styles['label'] = feature.getProperty('label');
        return styles;
      });
    }
    
    addDataLayerListeners(layer, layer_name){
      this.addClickEventToLayer(layer, layer_name);
      this.addMouseupEventToLayer(layer, layer_name);
      this.addMousedownEventToLayer(layer, layer_name);
      this.addMouseoverEventToLayer(layer, layer_name);
      this.addMouseoutEventToLayer(layer, layer_name);
    }
    
    addClickEventToLayer(layer, layer_name){
      if (!google.maps.event.hasListeners(layer, 'click')) {
        const click_event = layer.addListener('click', (event) => {
          if (event.feature.getProperty('draggable')) this.setIsDraggable(event.feature, false);
          if (this.deviceDrag) this.toggleDragMarkers();
          if (this.showAdvancedLocations) this.setAdvancedLocationsIsOpen();
          this.clickMarker(this.markers_map.get(event.feature.getId()));
        });
        this.map_layers_listeners.set(`${layer_name}_click`, click_event);
      }
    }

    addMouseupEventToLayer(layer, layer_name){
      if (!google.maps.event.hasListeners(layer, 'mouseup')){
        const mouseup_event = layer.addListener('mouseup', (event) => {
        if (this.deviceDrag) {
          const point = event.feature.getGeometry();
          this.dragCurrentLocation = {lat: point.get().lat(), lng: point.get().lng()};
          if (!isEqual(this.dragPrevLocation, this.dragCurrentLocation)){
            this.dragOnly && !this.$route.path.includes('virtual-devices')
              ? this.$emit('dragend', this.dragMarker, this.dragCurrentLocation, this.dragPrevLocation)
              : this.confirmDragDialog = true;
          }
        }
        });
        this.map_layers_listeners.set(`${layer_name}_mouseup`, mouseup_event);  
      }
    }

    addMousedownEventToLayer(layer, layer_name){
      if (!google.maps.event.hasListeners(layer, 'mousedown')){
        const mousedown_event = layer.addListener('mousedown', (event) => {
          if (this.deviceDrag) {
            if (this.infoOpenedCurrent) this.closeInfoWindow();
            this.dragMarker = this.markers_map.get(event.feature.getId());
            const point = event.feature.getGeometry();
            this.dragPrevLocation.lat = point.get().lat();
            this.dragPrevLocation.lng = point.get().lng();
          }
        });
        this.map_layers_listeners.set(`${layer_name}_mousedown`, mousedown_event);
      }
    }

    addMouseoverEventToLayer(layer, layer_name){
      if (!google.maps.event.hasListeners(layer, 'mouseover')){
        const mouseover_event = layer.addListener('mouseover', (event) => {
          if (this.deviceDrag && !this.draggableFeatures.has(event.feature.getId())) {
            this.setIsDraggable(event.feature, true);
            this.draggableFeatures.set(event.feature.getId(), true);
          }
          if (!this.current_device && this.showAdvancedLocations){
            this.addPolylines(this.markers_map.get(event.feature.getId()));
          }else if (!this.current_device && !this.showAdvancedLocations && !this.dragMarker) {
            this.showCurrentInfoWindow(this.markers_map.get(event.feature.getId()));
          }
        });
        this.map_layers_listeners.set(`${layer_name}_mouseover`, mouseover_event);
      }
    }

    addMouseoutEventToLayer(layer, layer_name){
      if (!google.maps.event.hasListeners(layer, 'mouseout')){
        const mouseout_event = layer.addListener('mouseout', (event) => {
          if (!this.current_device && this.showAdvancedLocations) this.clearPolylines();
          if (!this.current_device && !this.showAdvancedLocations) this.closeInfoWindow();
        });
        this.map_layers_listeners.set(`${layer_name}_mouseout`, mouseout_event);
      }
    }

    setIsDraggable(feature, draggable) {
      try {
        const marker = this.markers_map.get(feature.getId());
        const options = this.cabinetPage && this.getCabinetPageMarkerOptions(marker) || this.getMarkerOptions(marker, 'advanced');

        const properties = { icon: options.icon, zIndex: feature.getProperty('zIndex'), draggable };
        if (feature.getProperty('label') !== undefined) properties['label'] = options['label'];
        this.map_layers.get('markers').overrideStyle(feature, properties);
      } catch (error) {
        console.warn(`setIsDraggable Error processing ${feature ? feature.getId() : 'unknown'} `);
      }
    }

    updateFeatureIcon(marker) {
      this.$nextTick(() => {
        try {
          // Check if marker exists in the current markers_map before attempting to update
          if (!this.markers_map.has(marker.id)) {
            console.debug(`Marker ${marker.id} not in current map view, skipping icon update`);
            return;
          }

          const feature = this.map_layers.get('markers').getFeatureById(marker.id);
          if (!feature) {
            console.warn(`Feature not found for marker ID: ${marker.id}`);
            return;
          }
          const layer_name = 'advanced';
          const options = this.cabinetPage && this.getCabinetPageMarkerOptions(marker) || this.getMarkerOptions(marker, layer_name);
          const properties = {
            icon: options.icon,
            zIndex: feature.getProperty('zIndex'),
            draggable: feature.getProperty('draggable')
          };
          if (feature.getProperty('label') !== undefined) properties['label'] = options['label'];
          this.map_layers.get('markers').overrideStyle(feature, properties);
        } catch (error) {
          console.error(`Error updating feature icon for marker ID: ${marker?.id || 'unknown'}`, error);
          // console.error('Problematic Problematicmarker:', JSON.stringify(marker, null, 2));
        }
      });
    }

    closeInfoWindow(){
      this.closeWindow();
      if (!this.group && !this.dragOnly) this.clearDeviceData(); 
    }

    closeWindow(){
      this.infoPositionCurrent = null;
      this.infoOpenedCurrent = false;
      this.infoContentCurrent = null;
    }

    setMapBounds(locations) {
      if (locations && locations.length && this.$store.state.Global.deviceClicked) {
        this.clickExternalDevice(this.$store.state.Global.deviceClicked);
      } else {
        this.group && this.groupDevices && this.groupDevices.size
        ? this.setBounds([...this.groupDevices.values()])
        : this.setBounds(locations || []);
      }
    }

    clickExternalDevice(id){
      const marker = this.getMarkerById(id);
      if (marker) {
        this.setBounds([marker]);
      }
      this.clickMarker(marker);
    }

    getMarkerById(id){
      return this.markers_map.get(id);
    }

    getInstalledWithValidLocation() {
      return this.devices.filter((device: Device) => {
        if (this.markers_map.has(device.id)) return false;
        if ((!device.has_valid_location || !this.$store.getters['Reports/commissioned_map'].has(device.id)) && !this.dragOnly) return false;
          if (!this.cabinetPage) return true;
          if (Utils.hasCabinetClass(device['meta.category'].category)) {
            const cabinet_id_value: string = device['meta.device'].cabinet_id;
            const cabinet_id = cabinet_id_value ? cabinet_id_value.toString() : '';
            if (cabinet_id === 'default') this.isDefaultCabinet = true;
          }
          return true;
        });
    }

    // getContainerMarker(device, container_id, coordinates) {
    //   return {
    //     id: device.id,
    //     container_id,
    //     class_name: 'CONTAINER',
    //     meta { 
    //      category: { category: 'CONTAINER' },
    //      location: { ...coordinates },
    //      device: device['meta.device'],
    //     }
    //   };
    // },
    clickMarker(marker) {
      if (!marker) return;
      
      if (this.showSelectionTools && this.deviceSelectorChecked || this.$route.path.includes('/groups/')) {
        this.$emit('markerClicked', [marker]);
        return;
      }

      if (Utils.hasCabinetClass(marker['meta.category'].category)) {
        this.$router.push(`/cabinet-details/${marker.id}`);
        return;
      }

      this.$emit('showDeviceInformation', marker);
      this.center = {lat: marker['meta.location'].lat, lng: marker['meta.location'].lng};
      this.setSearchClicked(false);
      setTimeout(() => this.showCurrentInfoWindow(marker), this.$store.state.Global.deviceClicked ? 500 : 0);
    }

    initSearch() {
      const input = document.getElementById('search-input') as HTMLInputElement;
      let tries = 0;
      const tryInit = () => {
        if (!this.$refs.map || !this.$refs.map.$mapPromise) {
          if (tries < 20) {
            tries += 1;
            setTimeout(tryInit, 50);
          }
          return;
        }

        this.$refs.map.$mapPromise.then((map) => {
          this.map = map;
          this.setMapLayers();
          this.whenMapReady();

          if (this.showSelectionTools) this.selectMarkersManager();
          Vue.set(this.mapOptions, 'zoomControlOptions', {
            position: google.maps.ControlPosition.LEFT_BOTTOM
          });
          Vue.set(this.mapOptions, 'streetViewControl', {
            position: google.maps.ControlPosition.LEFT_BOTTOM
          });
          if (input) {
            const searchBox = new window.google.maps.places.SearchBox(input);
            searchBox.addListener('places_changed', () => {
              const places = searchBox.getPlaces();
              if (places.length !== 0) {
                const location = places[0].geometry.location;
                const position = {
                  lat: location.lat(),
                  lng: location.lng()
                };
                map.panTo(position);
                this.smoothZoom(18, this.map.getZoom());
              }
            });
          }
          const thePanorama = this.map.getStreetView();
          thePanorama.addListener('visible_changed', () => {
            this.showLegend = !thePanorama.getVisible();
          });
          // if (this.fullviewPage){
          //   const zoom = map.addListener('zoom_changed', () => {
          //     const current_zoom = this.map.getZoom();
          //     if (current_zoom >= 15 && this.map_layers.get('cabinets_devices').getMap() === null){
          //       this.map_layers.get('cabinets_devices').setMap(this.map);
          //     }else if (current_zoom < 15 && this.map_layers.get('cabinets_devices').getMap() !== null){
          //       this.map_layers.get('cabinets_devices').setMap(null);
          //       if (this.$store.state.Global.deviceClicked) this.closeInfoWindow();
          //     }
          //   });
          // }
          
          // map.addListener('bounds_changed', async () => {
          //   await this.setMapCurrentBounds();
          // });
        });
      };

      this.$nextTick(() => {
        tryInit();
      });
    }

    // async setMapCurrentBounds(){
    //   const bounds = this.map.getBounds();
    //   if (bounds){
    //     const ne = bounds.getNorthEast();
    //     const sw = bounds.getSouthWest();
    //     if (ne.lat() && sw.lat() && ne.lng() && sw.lng()) {
    //       const hiLat = await ne.lat();
    //       const loLat = await sw.lat();
    //       const hiLng = await ne.lng();
    //       const loLng = await sw.lng();
    //       this.mapCurrentBounds = { hiLat, loLat, hiLng, loLng };
    //     }
    //   }
    // },
    drawPolygon(points) {
      if (points.length < 3) return;
      // first delete the previous polygon
      if (this.polygon) this.polygon.setMap(null);
      // @see https://developers.google.com/maps/documentation/javascript/examples/polygon-simple
      this.polygon = new google.maps.Polygon({
        paths: points,
        strokeColor: '#FF0000',
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: '#FF0000',
        fillOpacity: 0.35,
        map: this.$refs.map.$mapObject
      });
      // display to input
      this.displaySelectedMarkers();
    }

    displaySelectedMarkers() {
      const poly = google && google.maps.geometry.poly;
      // @see https://developers.google.com/maps/documentation/javascript/examples/poly-containsLocation
      this.polygonDevices = this.markers.filter((marker) =>
        poly.containsLocation(new google.maps.LatLng(marker['meta.location'].lat, marker['meta.location'].lng), this.polygon)
      );
    }

    addDevices(state = false) {
      this.$emit('selectedChanged', this.polygonDevices, state);
      this.deviceSelectorChecked = false;
      this.clearPolySelection();
    }

    addSelectedDevices(state = null) {
      this.$emit('selectedChanged', this.polygonDevices, state);
      this.clearPolySelection();
    }

    clearPolySelection() {
      if (this.polygon) this.polygon.setMap(null);
      this.polygonMarkers.forEach((polygon_marker) => polygon_marker.setMap(null));
      this.polygonMarkers = [];
      this.polygonLocations = [];
      this.polygonDevices = [];
    }

    handleKeyPress(e){
      if (e.code === 'Delete' && this.deviceSelectorChecked && this.polygonDevices.length > 0) {
        this.deviceSelectorChecked = false;
        this.clearPolySelection();
      }
    }

    handleMapClick(e){
      if (this.deviceSelectorChecked) {
        const position = e.latLng;
        this.polygonLocations.push(position);
        this.polygonMarkers.push(
          new google.maps.Marker({
            icon: config.icons.measle,
            position,
            map: this.$refs.map.$mapObject
          })
        );
        this.drawPolygon(this.polygonLocations);
      }
    }

    selectMarkersManager() {
      if (google.maps.event.hasListeners(this.map, 'click')) return;

      document.addEventListener('keypress', this.handleKeyPress);
      this.map.addListener('click', this.handleMapClick);
    }

    isMarkerInsideMapBounds(marker){
      return this.$refs.map.$mapObject.getBounds().contains({lat: marker['meta.location'].lat, lng: marker['meta.location'].lng});
    }

    showCurrentInfoWindow(marker) {
      this.infoPositionCurrent = { lat: marker['meta.location'].lat, lng: marker['meta.location'].lng };
      this.infoContentCurrent = this.getMarkerText(marker);
      this.infoOpenedCurrent = true;
    }

    addPolylines(marker){
      this.clearPolylines();
      if (marker.hasOwnProperty('meta.install_location')) {
        const pathstart = [new google.maps.LatLng(marker['meta.location'].lat, marker['meta.location'].lng)];
        if (this.advancedLocations['gps']){
          const gps_feature = this.map_layers.get('gps').getFeatureById(`gps_${marker.id}`);
          if (gps_feature) this.setPolylinePath('polyline', 'green', gps_feature, pathstart);
        }
        if (this.advancedLocations['gis']){
          const gis_feature = this.map_layers.get('gis').getFeatureById(`gis_${marker.id}`);
          if (gis_feature) this.setPolylinePath('polyline1', 'red', gis_feature, pathstart);
        }
        if (this.advancedLocations['app']){
          const app_feature = this.map_layers.get('app').getFeatureById(`app_${marker.id}`);
          if (app_feature) this.setPolylinePath('polyline2', 'purple', app_feature, pathstart);
        }
      }
    }

    setPolylinePath(polyline, color, feature, pathstart){
      this[polyline] = this.createPolyline(color);
      const geometry = feature.getGeometry();
      const path = [...pathstart, new google.maps.LatLng(geometry.get().lat(), geometry.get().lng())];
      this[polyline].setPath(path);
      this[polyline].setMap(this.map);
    }

    createPolyline(strokeColor){
      return new google.maps.Polyline({
        strokeColor,
        strokeOpacity: 0.4
      });
    }

    getMarkerText(device) {
      const newDevice = deviceFactory.createDevice(device);
      return newDevice.getPopUpText();
    }

    setMarkerCoords(location, marker_id) {
      const marker = this.markers_map.get(marker_id);
      marker['meta.location'] = location;
    }

    setMapStyles(name) {
      if (this.hasCustomMapStyles) {
        const copy_map_styles = cloneDeep(this.customMapStyles);
        let defaultStyle = mapStyles['defaultMode'];
        Object.entries(copy_map_styles).forEach(([map_type, style]) => {
          style[0].default = this.mapMode === map_type;
          if (style[0].default) defaultStyle = style[0].style[0];
        });

        const prop = {
          name: 'dashboard.map_styles',
          objectID: this.$store.state.User.project.id,
          objectType: Types.PROJECTS
        };

        this.$refs.propEditor.save(
          copy_map_styles,
          prop,
          async () => {
            Object.entries(this.customMapStyles).forEach(([map_type, style]) => style[0].default = this.mapMode === map_type);
            // localStorage.setItem('mapMode', this.mapMode);
            Vue.set(this.mapOptions, 'styles', defaultStyle);
          },
          'Default style changed'
        );
      } else {
        // localStorage.setItem('mapMode', this.mapMode);
        Vue.set(this.mapOptions, 'styles', mapStyles[this.mapMode]);
      }
      this.toggleMapSettings();
    }

    setMapStyle(field_name, value) {
      Vue.set(this.mapStyles, field_name, value);
    }

    toggleSearch() {
      if (this.showSettings) this.showSettings = false;
      this.openSearch = !this.openSearch;
      this.search_value = '';
    }

    toggleMapSettings() {
      this.showSettings = !this.showSettings;
    }

    toggleDragMarkers() {
      if (this.showSettings) this.showSettings = false;
      this.$store.commit('MapSettings/setDeviceRepositioning', !this.deviceDrag );
      this.dragMarker = null;
      this.clearDragLocations();
      if (!this.deviceDrag){
        if (this.confirmDragDialog) this.confirmDragDialog = false;
        if (this.draggableFeatures.size){
          [...this.draggableFeatures.keys()].forEach((feature_id) => {
            const feature = this.map_layers.get('markers').getFeatureById(feature_id);
            this.setIsDraggable(feature, false);
          });
          this.draggableFeatures = new Map();
        }
      }
    }

    setDefaultProjectMapStyle() {
      this.hasCustomMapStyles = false;
      this.styleList = defaultStyleSheet;
      this.mapMode = 'defaultMode';
      Vue.set(this.mapOptions, 'styles', mapStyles[this.mapMode]);
    }

    getProjectMapStyles() {
      try {
        const styleList = [{ name: 'Default', value: 'defaultMode' }];
        const map_styles = PropUtils.getProperty(this.projectProperties, 'dashboard.map_styles');
        let defaultType = 'defaultMode';
        let defaultStyle = mapStyles['defaultMode'];
        if (map_styles && map_styles.value) {
          this.customMapStyles = map_styles.value;
          Object.entries(this.customMapStyles).forEach(([map_type, style]) => {
            const current_style = style[0];
            if (current_style.default) {
              defaultType = map_type;
              defaultStyle = current_style.style[0];
            }
            styleList.push({name: map_type, value: map_type});
          });
        }
        if (styleList.length > 1) {
          this.hasCustomMapStyles = true;
          this.mapMode = defaultType;
          this.styleList = styleList;
          // localStorage.setItem('mapMode', defaultType);
          Vue.set(this.mapOptions, 'styles', defaultStyle);
        } else {
          this.setDefaultProjectMapStyle();
        }
      } catch (e) {
        console.log('err', e);
        this.setDefaultProjectMapStyle();
      }
    }

    setBounds(markers) {
      if (typeof this.$gmapApiPromiseLazy !== 'function') {
        return;
      }

      this.$gmapApiPromiseLazy().then(() => {
        if (typeof google === 'undefined' || !google.maps) {
          return;
        }

        const bounds = new google.maps.LatLngBounds();
        if (!markers.length) {
          bounds.extend(new google.maps.LatLng(this.projectDefaultLocation.lat, this.projectDefaultLocation.lng));
          // logic to change map zoom if we don`t have markers
          if (bounds.getNorthEast().equals(bounds.getSouthWest())) {
            const extendPoint1 = new google.maps.LatLng(
              bounds.getNorthEast().lat() + 0.01,
              bounds.getNorthEast().lng() + 0.01
            );
            const extendPoint2 = new google.maps.LatLng(
              bounds.getNorthEast().lat() - 0.01,
              bounds.getNorthEast().lng() - 0.01
            );
            bounds.extend(extendPoint1);
            bounds.extend(extendPoint2);
          }
        }else {
          markers.forEach((marker) => {
            bounds.extend(new google.maps.LatLng(marker['meta.location'].lat, marker['meta.location'].lng));
          });
        }
        if (this.$refs.map && this.$refs.map.$mapObject) {
          this.$refs.map.$mapObject.fitBounds(bounds);
        }
      });
    }

    linkLayerToMap(layer_name){
      const layer = this.map_layers.get(layer_name);
      Vue.set(this.advancedLocations, layer_name, !this.advancedLocations[layer_name]);
      this.advancedLocations[layer_name]
        ? layer.setMap(this.map)
        : layer.setMap(null);
    }

    clearPolylines(){
      if (this.polyline) this.polyline.setMap(null);
      if (this.polyline1) this.polyline1.setMap(null);
      if (this.polyline2) this.polyline2.setMap(null);
    }

    setDragMarker(value){
      this.dragMarker = value;
    }

    revertDrag(){
      this.confirmDragDialog = false;
      const point = this.map_layers.get('markers').getFeatureById(this.dragMarker.id);
      point.setGeometry(new google.maps.Data.Point({...this.dragPrevLocation}));
      this.dragMarker = null;
      this.clearDragLocations();
    }
    
    async updateDevicePosition(){
      const drag_marker = cloneDeep(this.dragMarker);
      const current_location = {...this.dragCurrentLocation};
      this.dragMarker = null;
      this.confirmDragDialog = false;
      const prop = {
        name: 'meta.location', // לפרופרטי אחר meta.locationשינוי מיקום מכשיר מ
        value: {},
        objectID: drag_marker.id,
        objectType: Types.DEVICES
      };
      if (this.$route.path.includes('/virtual-devices')) this.$emit('changeVirtualLocation', current_location);
      this.$refs.propEditor.save(
        {lat: current_location.lat.toString(), lng: current_location.lng.toString()},
        prop,
        async () => {
          this.closeInfoWindow();
          this.map_layers.get('markers').getFeatureById(drag_marker.id).setGeometry(new google.maps.Data.Point({...current_location}));

          this.setMarkerCoords(current_location, drag_marker.id);
          if (drag_marker.hasOwnProperty('meta.install_location') && drag_marker['meta.install_location']) {
            this.updateInstallLocationProperty(drag_marker, current_location);
          }
          this.updateMarkerAddress(drag_marker.id, current_location);
          this.clearDragLocations();
        },
        `Device location successfully updated`
      );
    }
    
    clearDragLocations(){
      this.dragPrevLocation = {lat: null, lng: null};
      this.dragCurrentLocation = {lat: null, lng: null};
    }
    
    async updateMarkerAddress(device_id, current_location){
      const url = 'device/update_estimated_address';
      const body = {
        device_id,
        company_id: this.$store.state.User.project.company,
        project_id: this.$store.state.User.project.id,
        lat: current_location.lat,
        lng: current_location.lng
      };

      const response = await API.dashboardAPI(url, 'POST', {}, body);
      if (response && response.address) {
        const map_marker = this.markers_map.get(device_id);
        const meta_device = map_marker['meta.device'];
        const address_field = Utils.hasCabinetClass(map_marker['meta.category'].category) ? 'cabinet_address' : 'address';
        meta_device[address_field] = response.address;
        map_marker['meta.device'] = meta_device;
      }
    }

    async getLastPropertyHistory(property_name, device_id) {
      const property_history = await API.get(
        Types.DEVICES,
        `${device_id}/properties/${property_name}/history`,
        {}
      );
      return property_history.length ? property_history[0] : '';
    }

    async updateInstallLocationProperty(device, new_location) {
      const last_location = this.$store.state.User.role === 'CA'
        ? await this.getLastPropertyHistory('meta.location', device.id)
        : '';
      const install_location_prop = device['meta.install_location'];
      install_location_prop.manual_location = {lat: new_location.lat.toString(), lng: new_location.lng.toString()};

      if (last_location) {
        if (last_location.updater.toString() === device.id) {
          try {
            const property_value = JSON.parse(last_location.value);
            install_location_prop.gps_location = property_value;
          } catch (e) {}
        }
      }

      const prop = {
        name: 'meta.install_location',
        value: {},
        objectID: device.id,
        objectType: Types.DEVICES
      };
      this.$refs.propEditor.save(install_location_prop, prop);
    }

    removeAllLayerFeatures(layer_name){
      this.map_layers.get(layer_name).forEach((feature) => {
        this.map_layers.get('markers').remove(feature);
      });
    }
   
  @Watch('devices')
  whenMapReady() {
    if (!this.map) return;
    
    setTimeout(() => {
      this.setMarkerInformation();
    }, 0);
  }

  @Watch('projectProperties')
  whenProjectPropertiesChanged(prev, next) {
    if (prev.length) {
      this.getProjectMapStyles();
    }
  }
}

export default GoogleMap;
